module.exports = __webpack_public_path__ + "afca51d5d4d57628c35ba37cfcd0ca9b.png";